import { store } from 'src/store';
import { OAuthToken } from 'src/domains/global/types';
import {
    ComponentConf,
    ResourceComp,
    isResourceComp,
    systemFields,
    systemResources,
    systemResourcesAdminWhitelist,
    systemResourcesUserWhiteList,
    systemFieldsAdminWhitelist,
    systemFieldsUserWhiteList
} from 'src/config';


export interface Role {
    key: string
    manage: boolean
}

export enum AccessLevel {
    Read,
    Manage
}

export interface User {
    id: string | null
    username: string
    roles: Role[]
    root: boolean
}

export class Principal implements User {
    user: User;

    get id() { return this.user.id }
    get username() { return this.user.username }
    get roles() { return this.user.roles }
    get root() { return this.user.root }

    constructor(user: User) {
        this.user = user;
    }

    // Single means non-array (ComponentConf)
    private hasAccessSingle(cc: ComponentConf, level: AccessLevel) {
        const resourceName = isResourceComp(cc) ? (cc as ResourceComp).resourceName : null;
        return resourceName == null || this.hasAccessResource(resourceName, level);
    }

    public hasAccess(cc: ComponentConf | ComponentConf[], level: AccessLevel) {
        return this.root || (Array.isArray(cc) ? cc.find(ccSingle => !this.hasAccessSingle(ccSingle, level)) === undefined : this.hasAccessSingle(cc, level));
    }

    public hasAccessResource(resName: string, level: AccessLevel) {
        return this.root || this.roles.find(role => role.key === resName && (level === AccessLevel.Read || role.manage)) != null;
    }

    public getAccessLevel(resName: string) {
        if (this.root) {
            return AccessLevel.Manage;
        } else {
            const role = this.roles.find(role => role.key === resName);
            return role != null ? role.manage ? AccessLevel.Manage : AccessLevel.Read : null;
        }
    }
}

const getPrincipal: () => Principal = () => {
    const token: OAuthToken | null = store.getState().global.login.token;

    return new Principal(token != null ? token.user : {
        id: null,
        username: '',
        roles: [],
        root: false
    })
}

export const isResourceAllowed: (resourceName: string) => boolean = (resourceName) => {
    const principal: Principal = getPrincipal();
    return !systemResources.includes(resourceName) || (principal.root && systemResourcesAdminWhitelist.includes(resourceName)) || systemResourcesUserWhiteList.includes(resourceName);
}

export const isFieldAllowed: (fieldName: string) => boolean = (fieldName) => {
    const principal = getPrincipal();
    return !systemFields.includes(fieldName) || (principal.root && systemFieldsAdminWhitelist.includes(fieldName)) || systemFieldsUserWhiteList.includes(fieldName);
}

export { getPrincipal }
